import { render, staticRenderFns } from "./PolicyModal.vue?vue&type=template&id=30cb2982&scoped=true"
import script from "./PolicyModal.vue?vue&type=script&lang=js"
export * from "./PolicyModal.vue?vue&type=script&lang=js"
import style0 from "./PolicyModal.vue?vue&type=style&index=0&id=30cb2982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb2982",
  null
  
)

export default component.exports